angular.module('agreements')
    .controller('AgreementAddTouchOnlyController', function ($scope, $rootScope, $uibModalInstance, data, Agreement, AgreementConst) {
        this.$onInit = () => {
            this.form = {
                id: data,
                worker: null
            }
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            return Agreement.addTouchOnly(this.form).$promise
                .then(() => {
                    $uibModalInstance.close()
                    $rootScope.$broadcast(AgreementConst.eventUpdate)
                })
        }
    })
